





















































































































































































































import { Component, Vue } from 'vue-property-decorator'
import adminPanelApi from '@/api/admin-panel'
import {
    TelephonyServerAEditDto
} from "@/global";
import * as enums from "@/global-enum";
import Helpers from '../../helpers'

@Component({
    components: {
    }
})
export default class AdminPanel_EditTelephonyServer extends Vue {
    isLoading = true;
    isButtonsDisabled = false;

    telephonyServer: TelephonyServerAEditDto | null = null;

    mounted() {
        if (this.isTelephonyServerCreate) {
            this.telephonyServer = {
                id: 0,

                name: '',

                isControllable: false,
                serverAddress: '',
                serverLogin: '',
                serverPassword: '',

                robotAddressPool: '',

                phoneNumbersFirstPrefix: '',
                phoneNumbersSecondPrefix: '',
            } as TelephonyServerAEditDto;

            this.isLoading = false;
        } else {
            this.updateEditModel();
        }
    }

    get validateForm(): boolean {
        return !this.veeErrors.any();
    }

    get isTelephonyServerCreate() {
        return this.$route.name === 'create-telephony-server';
    }

    updateEditModel() {
        if (!this.$helpers.isExists(this.$route.params.id)) return;

        this.isLoading = true;

        adminPanelApi.getTelephonyServerEdit(this.$helpers.toNumeric(this.$route.params.id), ((dto) => {
            this.telephonyServer = dto;

            this.isLoading = false;
        }), errorMessage => {
            this.showError(errorMessage);

            this.isLoading = false;
        });
    }

    validateState(ref: string) {
        if (this.veeFields[ref] &&
            (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
            return !this.veeErrors.has(ref);
        }

        return null
    }

    showError(errorMessage?: string) {
        this.$bvToast.toast(errorMessage || "Спробуйте пізніше", {
            title: "Помилка",
            variant: "danger"
        })
    }

    async updateTelephonyServer() {
        this.isButtonsDisabled = true;

        let isValid = this.$helpers.isExists(this.telephonyServer);

        if (!await this.$validator.validateAll()) {
            isValid = false;
        }

        if (isValid) {
            adminPanelApi.updateTelephonyServerEdit(this.telephonyServer!, (data) => {
                if (data.success) {
                    if (this.isTelephonyServerCreate) {
                        if (this.$helpers.isNumeric(data.id)) {
                            this.$router.push({ name: 'edit-telephony-server', params: { id: data.id!.toString() } });

                            // force update model
                            this.updateEditModel();
                        } else {
                            this.$router.push({ name: 'telephony-servers-table' })
                        }

                        this.$bvToast.toast("Зміни успішно збережені", {
                            title: "Успіх",
                            variant: "success"
                        });
                    } else {
                        if (data.isAnyChanges) {
                            this.$bvToast.toast("Зміни успішно збережені", {
                                title: "Успіх",
                                variant: "success"
                            });
                        } else {
                            this.$bvToast.toast("Зміни не потрібні, інформація в актуальному стані", {
                                title: "Повідомлення",
                                variant: "info"
                            });
                        }
                    }
                } else {
                    this.showError()
                }

                this.isButtonsDisabled = false;
            }, errorMessage => {
                this.isButtonsDisabled = false;

                this.showError(errorMessage)
            });
        } else {
            this.isButtonsDisabled = false;
        }
    }

    deleteTelephonyServerWithConfirm() {
        if (!this.$helpers.isExists(this.telephonyServer)) return;

        this.$bvModal.msgBoxConfirm(`Ви дійсно хочете видалити сервер телефонії "${this.telephonyServer!.name}"?`, {
            title: "Видалити сервер телефонії",
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'Видалити',
            cancelTitle: 'Відміна',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        })
            .then(value => {
                if (value) {
                    this.isButtonsDisabled = true;

                    adminPanelApi.deleteTelephonyServer(this.telephonyServer!.id, data => {
                        if (data.success) {
                            this.$router.push({ name: 'telephony-servers-table' })
                        }

                        this.isButtonsDisabled = false;
                    }, errorMessage => {
                        this.showError(errorMessage);

                        this.isButtonsDisabled = false;
                    })
                }
            })
            .catch(err => {
                // An error occurred
            })
    }

    changeMainServerWithConfirm() {
        if (!this.$helpers.isExists(this.telephonyServer) || this.telephonyServer!.isMain) return;

        this.$bvModal.msgBoxConfirm(`Ви дійсно хочете зробити ${this.telephonyServer!.name} основним сервером телефонії?`, {
            title: `Зміна основного сервера телефонії`,
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'Змінити',
            cancelTitle: 'Відміна',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        })
            .then(value => {
                if (value) {
                    this.isButtonsDisabled = true;

                    adminPanelApi.changeMainServer(this.telephonyServer!.id, data => {
                        if (data.success) {
                            this.telephonyServer!.isMain = true;
                        }

                        this.isButtonsDisabled = false;
                    }, errorMessage => {
                        this.showError(errorMessage);

                        this.isButtonsDisabled = false;
                    })
                }
            })
            .catch(err => {
                // An error occurred
            })
    }
}
